module.exports = __webpack_public_path__ + "static/media/icon_invoices.95f09274.svg";